import defaultAttributes from '../defaultAttributes';

const AlignVerticalJustifyStart = [
  'svg',
  defaultAttributes,
  [
    ['rect', { x: '5', y: '16', width: '14', height: '6', rx: '2' }],
    ['rect', { x: '7', y: '6', width: '10', height: '6', rx: '2' }],
    ['path', { d: 'M2 2h20' }],
  ],
];

export default AlignVerticalJustifyStart;
